import React, { useState, useEffect, useMemo } from "react";
import AdminList from "../components/Users/AdminList";
import Filters from "../components/Users/Filters";
import useUsers from "../hooks/useUsers";
import { toast } from "react-hot-toast";

const Users = () => {
  const { users, isLoading, error, message } = useUsers();
  const [admins, setAdmins] = useState([]);
  const [groupId, setGroupId] = useState("all");
  const [roleId, setRoleId] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  // Toast messages from server
  useEffect(() => {
    if (message) {
      console.log("Server message:", message);
      toast.success(message);
    }
  }, [message]);

  // Keep admins once loaded — do not clear on empty users
  useEffect(() => {
    if (users && users.length > 0) {
      setAdmins(users);
    }
  }, [users]);

  // Always read currentUser values from localStorage
  const currentUser = useMemo(() => {
    return {
      id: localStorage.getItem("admin_id"),
      group_id: localStorage.getItem("group_id"),
      role_id: localStorage.getItem("role_id"),
    };
  }, [localStorage.getItem("admin_id"), localStorage.getItem("group_id"), localStorage.getItem("role_id")]);

  return (
    <div className="min-h-screen p-0 sm:p-2">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8 pl-2 flex items-center space-x-3">
          <h1 className="text-2xl font-semibold tracking-tight text-ink">
            Users Dashboard
          </h1>
        </div>

        {/* Filters */}
        <Filters
          groupId={groupId}
          setGroupId={setGroupId}
          roleId={roleId}
          setRoleId={setRoleId}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        {/* Admin List */}
        {isLoading && admins.length === 0 ? (
          <p className="text-gray-500">Loading admins...</p>
        ) : error && admins.length === 0 ? (
          <p className="text-red-500">Error: {error}</p>
        ) : (
          <AdminList
            admins={admins}
            setAdmins={setAdmins}
            currentUser={currentUser}
            filters={{ groupId, roleId, searchTerm }}
          />
        )}
      </div>
    </div>
  );
};

export default Users;
